export enum RightNavBarActionTypes {
  TOGGLE = "RIGHT_NAVBAR_TOGGLE",
  SELECT_OPTION = "RIGHT_NAVBAR_SELECT_OPTION",
  TOGGLE_EDIT = "RIGHT_NAVBAR_TOGGLE_EDIT",
  TOGGLE_CHANGE = "RIGHT_NAVBAR_TOGGLE_CHANGE",
}
